import './StoreButtons.css';
import appStoreBadge from '../../assets/appstore.png';
import googlePlayBadge from '../../assets/googlepaly.png';

export function AppStoreButton({ href = '#app-store', className = '' }) {
  return (
    <a
      className={`store-btn ${className}`.trim()}
      href={href}
      aria-label="Pobierz na App Store"
    >
      <img src={appStoreBadge} alt="" />
    </a>
  );
}

export function GooglePlayButton({ href = '#google-play', className = '' }) {
  return (
    <a
      className={`store-btn ${className}`.trim()}
      href={href}
      aria-label="Pobierz na Google Play"
    >
      <img src={googlePlayBadge} alt="" />
    </a>
  );
}
